export class ConceptField {
  constructor(public name: string,
              public title: string,
              public type: string,
              public sortable: boolean) {

  }
}
